import { useState, useEffect } from 'react';
import RenderIf from '@components/RequestProject/RenderIf';
import TitleSection from '@styles/requestViews/TitleSection';
import Description from '@styles/requestViews/Description';
import Button from '@components/RequestProject/Formik/Button';
import { useSupportedBrowser } from '@recorder/hooks/useSupportedBrowser';
import { Wrapper, Modal } from './styles';

const NotSupported = () => {
  const isBrowserSupported = useSupportedBrowser();
  const [showNotSupportedModal, setShowNotSupportedModal] = useState(false);
  useEffect(() => {
    if (!isBrowserSupported) {
      setShowNotSupportedModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function dismiss() {
    setShowNotSupportedModal(false);
  }
  return (
    <RenderIf condition={showNotSupportedModal}>
      <Wrapper>
        <Modal>
          <div className="info">
            <div style={{ fontSize: '32px' }}>✋</div>
            <TitleSection>
              This browser isn’t supported. Please use Google Chrome
            </TitleSection>
            <Description>
              While cam or screen recording isn’t supported for this browser
              yet, you can still upload a video from your computer or phone
            </Description>
            <Button secondary onClick={dismiss} backgroundColor="#6140ff">
              Ok - I’ll upload instead
            </Button>
          </div>
        </Modal>
      </Wrapper>
    </RenderIf>
  );
};

export default NotSupported;
